import React from 'react';
import { Link } from 'react-router-dom';
import { motion } from 'framer-motion';
import SafeIcon from '../../common/SafeIcon';
import { FiBarChart2, FiMail, FiPhone, FiPlus, FiUpload } from 'react-icons/fi';


const QuickActions = () => {
  const actions = [
    {
      title: 'Add Contact',
      description: 'Create a new contact',
      icon: FiPlus,
      color: 'blue',
      link: '/contacts'
    },
    {
      title: 'Import Contacts',
      description: 'Bulk import from CSV',
      icon: FiUpload,
      color: 'green',
      link: '/contacts'
    },
    {
      title: 'Create Campaign',
      description: 'Start email campaign',
      icon: FiMail,
      color: 'purple',
      link: '/campaigns'
    },
    {
      title: 'AI Call',
      description: 'Make AI-powered call',
      icon: FiPhone,
      color: 'orange',
      link: '/contacts'
    },
    {
      title: 'View Analytics',
      description: 'Check performance',
      icon: FiBarChart2,
      color: 'indigo',
      link: '/analytics'
    }
  ];

  const colorClasses = {
    blue: 'bg-blue-50 text-blue-600 hover:bg-blue-100',
    green: 'bg-green-50 text-green-600 hover:bg-green-100',
    purple: 'bg-purple-50 text-purple-600 hover:bg-purple-100',
    orange: 'bg-orange-50 text-orange-600 hover:bg-orange-100',
    indigo: 'bg-indigo-50 text-indigo-600 hover:bg-indigo-100'
  };

  return (
    <div className="bg-white rounded-xl shadow-sm border border-gray-200 p-6">
      <h3 className="text-lg font-semibold text-gray-900 mb-4">Quick Actions</h3>
      
      <div className="space-y-3">
        {actions.map((action, index) => (
          <motion.div
            key={action.title}
            initial={{ opacity: 0, x: -20 }}
            animate={{ opacity: 1, x: 0 }}
            transition={{ delay: index * 0.1 }}
          >
            <Link
              to={action.link}
              className="flex items-center p-3 rounded-lg hover:bg-gray-50 transition-colors group"
            >
              <div className={`w-10 h-10 rounded-lg ${colorClasses[action.color]} flex items-center justify-center transition-colors`}>
                <SafeIcon icon={action.icon} className="text-lg" />
              </div>
              
              <div className="ml-3">
                <p className="text-sm font-medium text-gray-900 group-hover:text-gray-700">
                  {action.title}
                </p>
                <p className="text-xs text-gray-500">{action.description}</p>
              </div>
            </Link>
          </motion.div>
        ))}
      </div>
    </div>
  );
};

export default QuickActions;